import { environment } from '@environments/environment';

export const GET_TUTOS_QUERY = (langcode: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_tutos,
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            term: {
              type: 'tuto',
            },
          },
        ],
      },
    },
    sort: [
      {
        weight: {
          order: 'asc',
        },
      },
    ],
    _source: ['title', 'body', 'url', 'image'],
  },
});
